<template>
  <nav class="navbar" role="navigation" aria-label="main navigation">
    <div class="navbar-brand">
      <a class="navbar-item" @click="$router.push('/')">
        <img src="../assets/fh_logo-inline-fff-txt.png" alt="Fault.Report: powered by FaultHero">
      </a>
      <a role="button" class="navbar-burger" :class="{ 'is-active': mobileMenuOpen }" aria-label="menu" aria-expanded="false" @click="mobileMenuToggle">
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
      </a>
    </div>
    <div class="navbar-menu" :class="{ 'is-active': mobileMenuOpen }" @click="mobileMenuToggle">
      <div class="navbar-end">
        <a class="navbar-item" @click="$router.push('/')">Home</a>
        <a class="navbar-item" @click="$router.push('/about')">What's This?</a>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  data () {
    return {
      mobileMenuOpen: false
    }
  },
  methods: {
    mobileMenuToggle () {
      this.mobileMenuOpen = !this.mobileMenuOpen
    }
  }

}
</script>

<style scoped lang="stylus">
.navbar-menu a
  transition: all 0.5s ease

.is-active
  @media (max-width: 1087px)
    text-align: right
    padding-right: 2rem
    background: #2d4a4e

.navbar-burger
  color: #d0cfbd

</style>
